/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as SettingsRouteImport } from './../../pages/settings'
import { Route as SearchRouteImport } from './../../pages/search'
import { Route as ReportsRouteImport } from './../../pages/reports'
import { Route as InboxRouteImport } from './../../pages/inbox'
import { Route as FocusRouteImport } from './../../pages/focus'
import { Route as EmployeesRouteImport } from './../../pages/employees'
import { Route as CompaniesRouteImport } from './../../pages/companies'
import { Route as BoardsRouteImport } from './../../pages/boards'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as TasksTaskIdRouteImport } from './../../pages/tasks.$taskId'
import { Route as MyTasksRouteImport } from './../../pages/my.tasks'
import { Route as MyProjectsRouteImport } from './../../pages/my.projects'
import { Route as GanttBoardIdRouteImport } from './../../pages/gantt.$boardId'
import { Route as EmployeesEmployeeIdRouteImport } from './../../pages/employees_.$employeeId'
import { Route as CompaniesCompanyIdRouteImport } from './../../pages/companies_.$companyId'
import { Route as BoardsBoardIdRouteImport } from './../../pages/boards_.$boardId'
import { Route as MyTasksTaskIdRouteImport } from './../../pages/my.tasks_.$taskId'
import { Route as MyProjectsProjectIdRouteImport } from './../../pages/my.projects_.$projectId'
import { Route as MyBoardsBoardIdRouteImport } from './../../pages/my.boards_.$boardId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const FocusRoute = FocusRouteImport.update({
  id: '/focus',
  path: '/focus',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsRoute = BoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyTasksRoute = MyTasksRouteImport.update({
  id: '/my/tasks',
  path: '/my/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const MyProjectsRoute = MyProjectsRouteImport.update({
  id: '/my/projects',
  path: '/my/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const GanttBoardIdRoute = GanttBoardIdRouteImport.update({
  id: '/gantt/$boardId',
  path: '/gantt/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesEmployeeIdRoute = EmployeesEmployeeIdRouteImport.update({
  id: '/employees_/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
  id: '/companies_/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsBoardIdRoute = BoardsBoardIdRouteImport.update({
  id: '/boards_/$boardId',
  path: '/boards/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyTasksTaskIdRoute = MyTasksTaskIdRouteImport.update({
  id: '/my/tasks_/$taskId',
  path: '/my/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyProjectsProjectIdRoute = MyProjectsProjectIdRouteImport.update({
  id: '/my/projects_/$projectId',
  path: '/my/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBoardsBoardIdRoute = MyBoardsBoardIdRouteImport.update({
  id: '/my/boards_/$boardId',
  path: '/my/boards/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/boards': typeof BoardsRoute
  '/companies': typeof CompaniesRoute
  '/employees': typeof EmployeesRoute
  '/focus': typeof FocusRoute
  '/inbox': typeof InboxRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdRoute
  '/gantt/$boardId': typeof GanttBoardIdRoute
  '/my/projects': typeof MyProjectsRoute
  '/my/tasks': typeof MyTasksRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/my/boards/$boardId': typeof MyBoardsBoardIdRoute
  '/my/projects/$projectId': typeof MyProjectsProjectIdRoute
  '/my/tasks/$taskId': typeof MyTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/boards': typeof BoardsRoute
  '/companies': typeof CompaniesRoute
  '/employees': typeof EmployeesRoute
  '/focus': typeof FocusRoute
  '/inbox': typeof InboxRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdRoute
  '/gantt/$boardId': typeof GanttBoardIdRoute
  '/my/projects': typeof MyProjectsRoute
  '/my/tasks': typeof MyTasksRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/my/boards/$boardId': typeof MyBoardsBoardIdRoute
  '/my/projects/$projectId': typeof MyProjectsProjectIdRoute
  '/my/tasks/$taskId': typeof MyTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/boards': typeof BoardsRoute
  '/companies': typeof CompaniesRoute
  '/employees': typeof EmployeesRoute
  '/focus': typeof FocusRoute
  '/inbox': typeof InboxRoute
  '/reports': typeof ReportsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/boards_/$boardId': typeof BoardsBoardIdRoute
  '/companies_/$companyId': typeof CompaniesCompanyIdRoute
  '/employees_/$employeeId': typeof EmployeesEmployeeIdRoute
  '/gantt/$boardId': typeof GanttBoardIdRoute
  '/my/projects': typeof MyProjectsRoute
  '/my/tasks': typeof MyTasksRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/my/boards_/$boardId': typeof MyBoardsBoardIdRoute
  '/my/projects_/$projectId': typeof MyProjectsProjectIdRoute
  '/my/tasks_/$taskId': typeof MyTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/boards'
    | '/companies'
    | '/employees'
    | '/focus'
    | '/inbox'
    | '/reports'
    | '/search'
    | '/settings'
    | '/boards/$boardId'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/gantt/$boardId'
    | '/my/projects'
    | '/my/tasks'
    | '/tasks/$taskId'
    | '/my/boards/$boardId'
    | '/my/projects/$projectId'
    | '/my/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/boards'
    | '/companies'
    | '/employees'
    | '/focus'
    | '/inbox'
    | '/reports'
    | '/search'
    | '/settings'
    | '/boards/$boardId'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/gantt/$boardId'
    | '/my/projects'
    | '/my/tasks'
    | '/tasks/$taskId'
    | '/my/boards/$boardId'
    | '/my/projects/$projectId'
    | '/my/tasks/$taskId'
  id:
    | '__root__'
    | '/'
    | '/boards'
    | '/companies'
    | '/employees'
    | '/focus'
    | '/inbox'
    | '/reports'
    | '/search'
    | '/settings'
    | '/boards_/$boardId'
    | '/companies_/$companyId'
    | '/employees_/$employeeId'
    | '/gantt/$boardId'
    | '/my/projects'
    | '/my/tasks'
    | '/tasks/$taskId'
    | '/my/boards_/$boardId'
    | '/my/projects_/$projectId'
    | '/my/tasks_/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BoardsRoute: typeof BoardsRoute
  CompaniesRoute: typeof CompaniesRoute
  EmployeesRoute: typeof EmployeesRoute
  FocusRoute: typeof FocusRoute
  InboxRoute: typeof InboxRoute
  ReportsRoute: typeof ReportsRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  BoardsBoardIdRoute: typeof BoardsBoardIdRoute
  CompaniesCompanyIdRoute: typeof CompaniesCompanyIdRoute
  EmployeesEmployeeIdRoute: typeof EmployeesEmployeeIdRoute
  GanttBoardIdRoute: typeof GanttBoardIdRoute
  MyProjectsRoute: typeof MyProjectsRoute
  MyTasksRoute: typeof MyTasksRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  MyBoardsBoardIdRoute: typeof MyBoardsBoardIdRoute
  MyProjectsProjectIdRoute: typeof MyProjectsProjectIdRoute
  MyTasksTaskIdRoute: typeof MyTasksTaskIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/focus': {
      id: '/focus'
      path: '/focus'
      fullPath: '/focus'
      preLoaderRoute: typeof FocusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees': {
      id: '/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards': {
      id: '/boards'
      path: '/boards'
      fullPath: '/boards'
      preLoaderRoute: typeof BoardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/tasks': {
      id: '/my/tasks'
      path: '/my/tasks'
      fullPath: '/my/tasks'
      preLoaderRoute: typeof MyTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/projects': {
      id: '/my/projects'
      path: '/my/projects'
      fullPath: '/my/projects'
      preLoaderRoute: typeof MyProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gantt/$boardId': {
      id: '/gantt/$boardId'
      path: '/gantt/$boardId'
      fullPath: '/gantt/$boardId'
      preLoaderRoute: typeof GanttBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees_/$employeeId': {
      id: '/employees_/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof EmployeesEmployeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId': {
      id: '/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof CompaniesCompanyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards_/$boardId': {
      id: '/boards_/$boardId'
      path: '/boards/$boardId'
      fullPath: '/boards/$boardId'
      preLoaderRoute: typeof BoardsBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/tasks_/$taskId': {
      id: '/my/tasks_/$taskId'
      path: '/my/tasks/$taskId'
      fullPath: '/my/tasks/$taskId'
      preLoaderRoute: typeof MyTasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/projects_/$projectId': {
      id: '/my/projects_/$projectId'
      path: '/my/projects/$projectId'
      fullPath: '/my/projects/$projectId'
      preLoaderRoute: typeof MyProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/boards_/$boardId': {
      id: '/my/boards_/$boardId'
      path: '/my/boards/$boardId'
      fullPath: '/my/boards/$boardId'
      preLoaderRoute: typeof MyBoardsBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BoardsRoute: BoardsRoute,
  CompaniesRoute: CompaniesRoute,
  EmployeesRoute: EmployeesRoute,
  FocusRoute: FocusRoute,
  InboxRoute: InboxRoute,
  ReportsRoute: ReportsRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  BoardsBoardIdRoute: BoardsBoardIdRoute,
  CompaniesCompanyIdRoute: CompaniesCompanyIdRoute,
  EmployeesEmployeeIdRoute: EmployeesEmployeeIdRoute,
  GanttBoardIdRoute: GanttBoardIdRoute,
  MyProjectsRoute: MyProjectsRoute,
  MyTasksRoute: MyTasksRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  MyBoardsBoardIdRoute: MyBoardsBoardIdRoute,
  MyProjectsProjectIdRoute: MyProjectsProjectIdRoute,
  MyTasksTaskIdRoute: MyTasksTaskIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
